import * as React from 'react';
import Testimonial from 'src/entities/Testimonial';

export interface Props {
  testimonial: Testimonial;
}

class TestimonialComponent extends React.PureComponent<Props> {
  public render(): React.ReactNode {

    const background = 'url(' + this.props.testimonial.image + ')';

    return (
      <div
        style={{
          backgroundPosition: 'center top',
          backgroundSize: 'cover',
          backgroundImage: background
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-sm-8 col-sm-offset-4">
              <div className="gap-50"/>
              <h4 className="deco-title line-height-30">
                {this.props.testimonial.name}
                <br/>
                <span className="f-w-100">
                {this.props.testimonial.title}
              </span>
              </h4>
              <div className="gap-20"/>
              <p>
                {this.props.testimonial.message}
              </p>
              <div className="gap-50"/>
              <div className="gap-50"/>
              <div className="gap-50"/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TestimonialComponent;


// WEBPACK FOOTER //
// ./src/modules/testimonial/Testimonial.component.tsx